import { render, staticRenderFns } from "./invoiceIssuerSettings.vue?vue&type=template&id=188df5c2&scoped=true"
import script from "./invoiceIssuerSettings.vue?vue&type=script&lang=js"
export * from "./invoiceIssuerSettings.vue?vue&type=script&lang=js"
import style0 from "./invoiceIssuerSettings.vue?vue&type=style&index=0&id=188df5c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188df5c2",
  null
  
)

export default component.exports